import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";

import { useGetTransfersList } from "../apis";
import { ETransferStatus } from "../constants";
import { GetTransfersParams } from "../transfers.types";

const useTransfersList = () => {
  const {
    page,
    sorting,
    searchValue,
    debouncedSearch,
    setSearchValue,
    setSorting,
    setPage,
  } = useManageTable({
    defaultSorting: [{ id: "createdAt", desc: true }],
  });

  const [status, setStatus] = useState<ETransferStatus | undefined>(undefined);

  useEffect(() => {
    setPage(1);
  }, [status, debouncedSearch]);

  const requestParams: GetTransfersParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      status,
      search: debouncedSearch || undefined,
    }),
    [page, sorting, status, debouncedSearch],
  );

  const {
    transfersList,
    meta,
    isLoading,
    refetch: refetchTransfers,
  } = useGetTransfersList(requestParams);

  return {
    transfersList,
    totalItems: meta?.itemCount ?? 0,
    page,
    isLoading,
    sorting,
    status,
    searchValue,
    setSearchValue,
    setStatus,
    setSorting,
    setPage,
    refetchTransfers,
  };
};

export default useTransfersList;
